import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  createUserGroup,
  deleteUserGroup,
  getUserGroups,
  updateUserGroup,
  UserGroupParams
} from '../api/userGroups';

// Only admins can read groups - pass enabled: false for anyone else, as a 403
// shows an error notification.
export const useUserGroupsQuery = ({ enabled = true }: { enabled?: boolean } = {}) => {
  return useQuery({
    queryKey: ['userGroups'],
    queryFn: () => getUserGroups(),
    enabled
  });
};

export const useCreateUserGroupMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: UserGroupParams) => createUserGroup(params),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['userGroups'] })
  });
};

export const useUpdateUserGroupMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, params }: { id: number; params: UserGroupParams }) =>
      updateUserGroup(id, params),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['userGroups'] })
  });
};

export const useDeleteUserGroupMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => deleteUserGroup(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['userGroups'] })
  });
};
